<script>
    import {onMount} from "svelte";
    import gsap from 'gsap';
    import MorphSVGPlugin from "gsap/MorphSVGPlugin";

    // Register gsap plugins here
    gsap.registerPlugin(MorphSVGPlugin);

    const timeline = gsap.timeline();

    const paths = Array.from(new Array(10)).map((_, i) => '#p' + i);

    onMount(() => {
      paths.forEach((selector, i) => {
        if (i < paths.length - 1) {
          timeline.to(selector, {morphSVG: paths[i + 1], duration: 1, repeat: -1, ease: 'linear'}, '<');
        }
      })
    });

</script>

<svg width=423 height="423" id="Base_planet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
     y="0px" viewBox="0 0 422 422" style="enable-background:new 0 0 422 422;" xml:space="preserve">
<style type="text/css">
	.st0{opacity:0.6;}

    .st1{opacity:0.72;fill:url(#SVGID_1_);stroke:url(#SVGID_00000127014078699834253410000017940152408515701130_);stroke-miterlimit:10;enable-background:new    ;}
    .st2{opacity:0.72;}

    .st3{opacity:0.72;fill:none;stroke:url(#SVGID_00000060724751976166003790000009040105786502401945_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}

    .st4{opacity:0.72;fill:none;stroke:url(#SVGID_00000081625888859326369400000011608974700309963416_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}

    .st5{opacity:0.72;fill:none;stroke:url(#SVGID_00000060737663026343461550000017807999371010355361_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}

    .st6{opacity:0.72;fill:none;stroke:url(#SVGID_00000039855838624863193880000015835171223987801243_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}

    .st7{opacity:0.72;fill:none;stroke:url(#SVGID_00000146489229138443248440000010881828668892726160_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}

    .st8{opacity:0.72;fill:none;stroke:url(#p9_00000080910450936983500590000015682704065290743984_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}
    .st9{fill:none;stroke:url(#p8_00000096749705082438917480000004992040222647534721_);stroke-width:2;stroke-miterlimit:10;}
    .st10{fill:none;stroke:url(#p7_00000044153667191447245880000006432582180960200084_);stroke-width:2;stroke-miterlimit:10;}
    .st11{fill:none;stroke:url(#p6_00000149371814057501181980000001503615237823808669_);stroke-width:2;stroke-miterlimit:10;}
    .st12{fill:none;stroke:url(#p5_00000056408309173519846830000017657725919269912504_);stroke-width:2;stroke-miterlimit:10;}
    .st13{fill:none;stroke:url(#p4_00000155832266003426506840000000075349620002662794_);stroke-width:2;stroke-miterlimit:10;}
    .st14{fill:none;stroke:url(#p3_00000096059993937417347020000010815549055858712214_);stroke-width:2;stroke-miterlimit:10;}
    .st15{fill:none;stroke:url(#p2_00000134941200493326795010000004582648035374539170_);stroke-width:2;stroke-miterlimit:10;}
    .st16{fill:none;stroke:url(#p1_00000095338670328256297790000005535386950180987531_);stroke-width:2;stroke-miterlimit:10;}

    .st17{opacity:0.72;fill:none;stroke:url(#p0_00000171701313059693322100000001332563913234351244_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}
</style>
    <g id="gradient" class="st0">

		<radialGradient id="SVGID_1_" cx="237.201" cy="829.9091" r="211.8155" gradientTransform="matrix(0.99 0 0 0.99 -24.36 -610.61)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <radialGradient id="SVGID_00000096019761243509290490000005214152472809102741_" cx="222.09" cy="822.87" r="212.11" gradientTransform="matrix(1 0 0 1 0 -656)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path style="opacity:0.72;fill:url(#SVGID_1_);stroke:url(#SVGID_00000096019761243509290490000005214152472809102741_);stroke-miterlimit:10;enable-background:new    ;" d="
		M421,211c0,116-94,210-210,210S1,327,1,211S95,1,211,1S421,95,421,211z"/>
</g>
    <g id="base-paths" class="st2">
	<g>

			<radialGradient id="SVGID_00000152239616032121075560000010184571156015518141_" cx="1643.3663" cy="8938.2012" r="197.44" gradientTransform="matrix(0 -1.17 0.99 0 -8655.6104 2121.4102)" gradientUnits="userSpaceOnUse">
			<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
                <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
                <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
                <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
                <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
                <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
                <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
                <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
                <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
                <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
                <stop  offset="1" style="stop-color:#FFFFFF"/>
		</radialGradient>

        <path style="opacity:0.72;fill:none;stroke:url(#SVGID_00000152239616032121075560000010184571156015518141_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
			M211,1c116,0,210,94,210,210s-94,210-210,210S1,327,1,211S95,1,211,1z"/>
	</g>
        <g>

			<radialGradient id="SVGID_00000165199539634649907070000012989547944408782781_" cx="758.935" cy="8938.2012" r="176.58" gradientTransform="matrix(0 -1.46 0.99 0 -8655.6104 1323.21)" gradientUnits="userSpaceOnUse">
			<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
                <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
                <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
                <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
                <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
                <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
                <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
                <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
                <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
                <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
                <stop  offset="1" style="stop-color:#FFFFFF"/>
		</radialGradient>

            <path style="opacity:0.72;fill:none;stroke:url(#SVGID_00000165199539634649907070000012989547944408782781_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
			M211,21c116,0,210,85.1,210,190s-94,190-210,190S1,315.9,1,211S95,21,211,21z"/>
	</g>
        <g>

			<radialGradient id="SVGID_00000012457287360695117640000013143222899726982053_" cx="-350.9819" cy="8938.2012" r="158.5" gradientTransform="matrix(0 -2.14 0.99 0 -8655.6104 -535.9502)" gradientUnits="userSpaceOnUse">
			<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
                <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
                <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
                <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
                <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
                <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
                <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
                <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
                <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
                <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
                <stop  offset="1" style="stop-color:#FFFFFF"/>
		</radialGradient>

            <path style="opacity:0.72;fill:none;stroke:url(#SVGID_00000012457287360695117640000013143222899726982053_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
			M211,61c116,0,210,67.2,210,150s-94,150-210,150S1,293.8,1,211S95,61,211,61z"/>
	</g>
        <g>

			<radialGradient id="SVGID_00000164489038585987622830000000823655329243242431_" cx="840.4286" cy="8938.2012" r="158.5" gradientTransform="matrix(0 -1.43 0.99 0 -8655.6104 1408.8202)" gradientUnits="userSpaceOnUse">
			<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
                <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
                <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
                <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
                <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
                <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
                <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
                <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
                <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
                <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
                <stop  offset="1" style="stop-color:#FFFFFF"/>
		</radialGradient>

            <path style="opacity:0.72;fill:none;stroke:url(#SVGID_00000164489038585987622830000000823655329243242431_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
			M211,111c116,0,210,44.8,210,100s-94,100-210,100S1,266.2,1,211S95,111,211,111z"/>
	</g>
        <g>

			<radialGradient id="SVGID_00000016036152577373313230000010314190816442647456_" cx="6194.5527" cy="8938.2012" r="158.5" gradientTransform="matrix(0 -0.57 0.99 0 -8655.6104 3754.5203)" gradientUnits="userSpaceOnUse">
			<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
                <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
                <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
                <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
                <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
                <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
                <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
                <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
                <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
                <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
                <stop  offset="1" style="stop-color:#FFFFFF"/>
		</radialGradient>

            <path style="opacity:0.72;fill:none;stroke:url(#SVGID_00000016036152577373313230000010314190816442647456_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
			M211,171c116,0,210,17.9,210,40s-94,40-210,40S1,233.1,1,211S95,171,211,171z"/>
	</g>
</g>
    <g id="spin-paths">

		<radialGradient id="p9_00000047778086808514573830000015896490491128429447_" cx="1643.3663" cy="9053.7471" r="141.4495" gradientTransform="matrix(0 -1.17 0.99 0 -8655.6104 2121.4102)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p9" style="opacity:0.72;fill:none;stroke:url(#p9_00000047778086808514573830000015896490491128429447_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
		M211,1c116,0,210,94,210,210s-94,210-210,210"/>

        <radialGradient id="p8_00000162316445868625793570000007097083919186369982_" cx="-479.7189" cy="252.5202" r="176.8456" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p8" style="fill:none;stroke:url(#p8_00000162316445868625793570000007097083919186369982_);stroke-width:2;stroke-miterlimit:10;" d="
		M213.6,421.9c104.9,0,190-94,190-210s-85.1-210-190-210"/>

        <radialGradient id="p7_00000137107483807406704260000015825356808030638779_" cx="-483.2454" cy="253.2778" r="167.5403" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p7" style="fill:none;stroke:url(#p7_00000137107483807406704260000015825356808030638779_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,1.1c82.8,0,150,94,150,210s-67.2,210-150,210"/>

        <radialGradient id="p6_00000100366228048944055660000006168829931883901581_" cx="-483.2772" cy="253.2778" r="167.2885" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p6" style="fill:none;stroke:url(#p6_00000100366228048944055660000006168829931883901581_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,1.1c55.2,0,100,94,100,210s-44.8,210-100,210"/>

        <radialGradient id="p5_00000075124798476030829110000002233803601045683628_" cx="-483.3459" cy="253.2778" r="169.6694" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p5" style="fill:none;stroke:url(#p5_00000075124798476030829110000002233803601045683628_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,1.1c22.1,0,40,94,40,210s-17.9,210-40,210"/>

        <radialGradient id="p4_00000063596014679468723210000017572226563656654001_" cx="-484.1654" cy="253.2778" r="176.8455" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p4" style="fill:none;stroke:url(#p4_00000063596014679468723210000017572226563656654001_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,1.1c-22.1,0-40,94-40,210s17.9,210,40,210"/>

        <radialGradient id="p3_00000108307983079885580870000014563560967887878303_" cx="-483.1905" cy="253.2778" r="176.8456" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p3" style="fill:none;stroke:url(#p3_00000108307983079885580870000014563560967887878303_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,1.1c-55.2,0-100,94-100,210s44.8,210,100,210"/>

        <radialGradient id="p2_00000103250271196777198020000008584763119373203117_" cx="-483.2454" cy="253.2778" r="176.8455" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p2" style="fill:none;stroke:url(#p2_00000103250271196777198020000008584763119373203117_);stroke-width:2;stroke-miterlimit:10;" d="
		M208.5,421.1c-82.8,0-150-94-150-210s67.2-210,150-210"/>

        <radialGradient id="p1_00000048481752410759711060000008662649288709854366_" cx="-482.6186" cy="252.5202" r="176.8456" gradientTransform="matrix(1.46 0 0 -0.99 914.39 461.87)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p1" style="fill:none;stroke:url(#p1_00000048481752410759711060000008662649288709854366_);stroke-width:2;stroke-miterlimit:10;" d="
		M209.4,1.9c-104.9,0-190,94-190,210s85.1,210,190,210"/>

        <radialGradient id="p0_00000099622097735447899170000007128815294031355066_" cx="1642.939" cy="8840.626" r="141.4495" gradientTransform="matrix(0 -1.17 0.99 0 -8655.6104 2121.4102)" gradientUnits="userSpaceOnUse">
		<stop  offset="0.2" style="stop-color:#FFFFFF;stop-opacity:0"/>
            <stop  offset="0.36" style="stop-color:#FFFFFF;stop-opacity:1.000000e-02"/>
            <stop  offset="0.46" style="stop-color:#FFFFFF;stop-opacity:5.000000e-02"/>
            <stop  offset="0.56" style="stop-color:#FFFFFF;stop-opacity:0.11"/>
            <stop  offset="0.64" style="stop-color:#FFFFFF;stop-opacity:0.19"/>
            <stop  offset="0.72" style="stop-color:#FFFFFF;stop-opacity:0.3"/>
            <stop  offset="0.79" style="stop-color:#FFFFFF;stop-opacity:0.44"/>
            <stop  offset="0.86" style="stop-color:#FFFFFF;stop-opacity:0.6"/>
            <stop  offset="0.93" style="stop-color:#FFFFFF;stop-opacity:0.78"/>
            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0.99"/>
            <stop  offset="1" style="stop-color:#FFFFFF"/>
	</radialGradient>

        <path id="p0" style="opacity:0.72;fill:none;stroke:url(#p0_00000099622097735447899170000007128815294031355066_);stroke-width:2;stroke-miterlimit:10;enable-background:new    ;" d="
		M211,421.5c-116,0-210-94-210-210s94-210,210-210"/>
</g>
</svg>
